export default __webpack_public_path__ + "static/media/ReversePlayIcon.d61ec501.svg";